export default __webpack_public_path__ + "static/media/a-c.1e666016.jpg";